import { axiosInstance } from ".."



const trelloCardInfo = async (projectID) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`/internal/pm/${projectID}`).then((res) => { 
            console.log(res)
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default trelloCardInfo;